import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import palette from 'src/theme/palette';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({ value, handleChange, tabs }) {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: palette.common.white,
        marginTop: 3,
        borderRadius: 2,
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="basic tabs example"
        sx={{ maxWidth: '100%', overflowX: 'auto' }}
      >
        {tabs.map((tab, i) => (
          <Tab key={i} label={tab.title} {...a11yProps(i)} style={{ fontSize: 16, height: 70 }} />
        ))}
      </Tabs>
    </Box>
  );
}
